export const DELETE_DIALOG_YES = 'OK';
export const DELETE_DIALOG_NO = 'Cancel';
export const ADD_DIALOG_YES = 'Save';
export const ADD_DIALOG_NO = 'Cancel';
export const DETAILS_PAGE_YES = 'Save';
export const DETAILS_PAGE_NO = 'Back';
export const DETAILS_PAGE_SUBMIT = 'Submit';
export const DIALOG_YES = 'OK';
export const DIALOG_NO = 'Cancel';
export const DIALOG_CLOSE = 'Close';
export const DIALOG_SAVE = 'Save';
export const DIALOG_CANCEL = 'Cancel';
export const DIALOG_SUBMIT = 'Submit';
